import { render } from "./MrFooter.vue?vue&type=template&id=2c117530"
import script from "./MrFooter.vue?vue&type=script&lang=js"
export * from "./MrFooter.vue?vue&type=script&lang=js"

import exportComponent from "/Users/philippschurig/PhpstormProjects/plenty_analytics_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__